module.exports = __webpack_public_path__ + "img/chinesecompany128.bef21f6d.png";